import type { IconProps } from './types';

export function Macacao({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 60 Q88 56 100 60 Q128 80 156 60 Q168 56 180 60 Q204 72 224 100 Q216 108 208 112 Q198 104 188 92 Q186 158 184 224 Q176 228 168 224 Q150 184 132 144 Q126 142 120 144 Q108 184 88 224 Q80 228 72 224 Q70 158 68 92 Q58 104 48 112 Q40 108 32 100 Q52 72 76 60 Z" />
    </svg>
  );
}
